/** The same bed demand as bulk allocation: lap infants do not need a bed. */
export function hotelGuests(passengers: readonly { paxType?: string }[]): number {
  return Math.max(1, passengers.filter((passenger) => passenger.paxType !== 'INF').length);
}
